import RfiActivityCard from './RfiActivityCard';

export default RfiActivityCard;
